var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGraphLinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 52 52"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M11.4227 5.6875C15.5263 2.73737 20.5603 1 26 1C39.8071 1 51 12.1929 51 26C51 39.8071 39.8071 51 26 51C12.1929 51 1 39.8071 1 26C1 23.8419 1.27346 21.7476 1.78761 19.75M14 16V17.7027M38 37H18C15.7909 37 14 35.2091 14 33V22.8108M36.4227 18.4402L38 16M17.5 33.3478L24.1414 23.3073C25.0403 21.8773 26.806 21.6771 27.9759 22.9044L29.33 24.3083C30.4988 25.52 32.2656 25.3355 33.1645 23.9054L34.5226 21.7129"
})));
export default SvgGraphLinline;